import { useCallback, useEffect, useRef, useState } from "react"
import { listModelFigures } from "~/api/model"

type ModelRequestStatus = "error" | "idle" | "loading" | "success"

export const useModelFigures = () => {
  const loadedRef = useRef(false)
  const requestIdRef = useRef(0)
  const loadingRef = useRef(false)
  const [error, setError] = useState("")
  const [items, setItems] = useState<API.Model.ModelFigure[]>([])
  const [status, setStatus] = useState<ModelRequestStatus>("idle")

  useEffect(() => {
    return () => {
      requestIdRef.current += 1
      loadedRef.current = false
      loadingRef.current = false
    }
  }, [])

  const load = useCallback(async () => {
    if (loadedRef.current || loadingRef.current) return

    const requestId = requestIdRef.current + 1

    requestIdRef.current = requestId
    loadingRef.current = true
    setError("")
    setStatus("loading")

    try {
      const response = await listModelFigures({ page: 0, page_size: 50 })

      if (requestId !== requestIdRef.current) return

      setItems(response.data?.items || [])
      setStatus("success")
      loadedRef.current = true
    } catch (requestError) {
      if (requestId !== requestIdRef.current) return

      setError(
        requestError instanceof Error
          ? requestError.message
          : "获取系统模特失败",
      )
      setStatus("error")
    } finally {
      if (requestId === requestIdRef.current) {
        loadingRef.current = false
      }
    }
  }, [])

  return { error, items, load, status }
}
